export enum ReminderFrequency {
    Monthly = 0,
    Quarterly = 1,
    Never = 10
}